import { jsx as _jsx } from "react/jsx-runtime";
import { FormikSingleSelect } from "~/components/Formik/FormikSingleSelect";
import { IMAGE_FORMAT_SINGLE_SELECT } from "~/constants/testIDs";
import { SUPPORTED_EXPORT_FORMATS } from "~/utils/Imgix";
const extensionOptions = SUPPORTED_EXPORT_FORMATS.map((format)=>({
        label: format.toUpperCase(),
        value: format
    }));
export const ExportImageExtSelect = (param)=>{
    let { setIsEditing } = param;
    return /*#__PURE__*/ _jsx(FormikSingleSelect, {
        isSearchable: false,
        size: "extra-large",
        "data-testid": IMAGE_FORMAT_SINGLE_SELECT,
        label: "Format",
        name: "ext",
        options: extensionOptions,
        onOptionsClose: ()=>{
            setIsEditing(false);
        },
        onOptionsOpen: ()=>{
            setIsEditing(true);
        },
        className: "min-w-[157px]"
    });
};
